'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileUploadsMapForThreadInProps = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _identifierForThread = require('../operators/identifierForThread');

var _getFileUploads = require('./getFileUploads');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileUploadsMapForThreadInProps = exports.fileUploadsMapForThreadInProps = (0, _reselect.createSelector)([_getFileUploads.getFileUploads, _threadFromProps.threadFromProps], function (fileUploads, thread) {
  var threadId = (0, _identifierForThread.identifierForThread)(thread);

  return (0, _get2.default)(threadId, fileUploads) || null;
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/selectors/fileUploadsMapForThreadInProps.js
// module id = 662
// module chunks = 2 3